import { Component, inject, Input, OnInit } from '@angular/core';
import { SelectModule } from 'primeng/select';
import { Session, SessionsService } from '../../services/sessions.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { Router } from '@angular/router';
import { DividerModule } from 'primeng/divider';
import { MenuModule } from 'primeng/menu';
import { AvatarModule } from 'primeng/avatar';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'app-besharp-active-session-badge',
  imports: [SelectModule, FormsModule, ReactiveFormsModule, ButtonModule, DividerModule, MenuModule, AvatarModule],
  templateUrl: './active-session-badge.component.html',
  styleUrl: './active-session-badge.component.scss',
})
export class DropdownSessionSelectorComponent implements OnInit {
  @Input() labelKey: string = 'username';
  @Input() imageKey: string | null = null;

  protected sessionsService: SessionsService = inject(SessionsService);
  protected router: Router = inject(Router);
  protected sessions: Session[];
  protected activeSession: Session | null;
  protected loading: boolean = false;
  protected activeSessionActions: MenuItem[] = [
    {
      label: 'Switch Session',
      icon: 'pi pi-users',
      command: () => this.router.navigate(['session', 'select']),
    },
    {
      label: 'Sign out',
      icon: 'pi pi-sign-out',
      command: () => {
        if (this.activeSession) {
          this.sessionsService.removeSession(this.activeSession?.id);
        }
      },
    },
  ];

  public constructor() {
    this.sessions = this.sessionsService.getSessions();
    this.activeSession = null;
  }
  async ngOnInit(): Promise<void> {
    this.loading = true;
    this.activeSession = await this.sessionsService.getActiveSession().finally(() => (this.loading = false));
  }
}
